export enum JoinType {
  LeftJoin = 'left join',
  RightJoin = 'right join',
  InnerJoin = 'inner join',
  FullJoin = 'full join',
}

export interface ITableJoinRelation {
  table_id: string; // 表id
  table_name: string; // 表名称
  customize_name: string; // 表显示名称
  customize_name_en: string; // 表显示名称英文
  table_code?: string; // 表别名:比如t0,t1,t2
  granularity: string;
  connect_type?: string; // 连接关系:left join、right join、inner join、full join
  on?: ITableJoinColumn[]; // 连接字段
  hide?: boolean; // 是否收起(UI展示用)
}

export interface ITableJoinColumn {
  left_condition: ITableJoinCondition; // 左表连接字段
  right_condition: ITableJoinCondition; // 右表连接字段
  operation: string; // 如何连接:目前写死"="
}

export interface ITableJoinCondition {
  table_id: string; // 表id
  table_code: string;
  column: string; // 字段名
  type?: string; // 字段类型
}
